import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableSortLabel,
} from '@material-ui/core';
import capitalize from '../../../stringUtils';
import './StatusTracking.scss';

const options = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  seconds: '2-digit',
  timeZone: 'UTC',
};

const tableHeaders = [
  {
    id: 'old_status', numeric: false, disablePadding: false, label: 'Old Status',
  },
  {
    id: 'new_status', numeric: false, disablePadding: false, label: 'New Status',
  },
  {
    id: 'change_reason', numeric: false, disablePadding: false, label: 'Change Reason',
  },
  {
    id: 'user_email', numeric: false, disablePadding: false, label: 'Updated By',
  },
  {
    id: 'created_at_with_time', numeric: false, disablePadding: false, label: 'Change Timestamp',
  },
];

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

const getComparator = (order, orderBy) => (order === 'desc'
  ? (a, b) => descendingComparator(a, b, orderBy)
  : (a, b) => -descendingComparator(a, b, orderBy));

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

function StatusTracking({ statusTracking }) {
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('created_at_with_time');

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <TableContainer>
      <Table
        aria-labelledby="tableTitle"
        size="medium"
        aria-label="enhanced table"
      >
        <TableHead>
          <TableRow>
            {tableHeaders.map((th) => (
              <TableCell
                key={th.id}
                padding={th.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === th.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === th.id}
                  direction={orderBy === th.id ? order : 'asc'}
                  onClick={createSortHandler(th.id)}
                >
                  {th.label}
                  {orderBy === th.id ? (
                    <span className="sort-arrow">
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              </TableCell>

            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {stableSort(statusTracking, getComparator(order, orderBy)).map((tb, index) => (
            <TableRow key={`${index}-${tb.user_email}`}>
              <TableCell>{capitalize(tb.old_status)}</TableCell>
              <TableCell>{capitalize(tb.new_status)}</TableCell>
              <TableCell>{tb.change_reason}</TableCell>
              <TableCell>{tb.user_email}</TableCell>
              <TableCell>
                {new Date(tb.created_at_with_time).toLocaleDateString('en-US', options)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

StatusTracking.propTypes = {
  statusTracking: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default StatusTracking;
